import { InferResult } from 'kysely';
import { datasetQueryBuilder } from '../datasetQueryBuilder';

const feedDateRangeSelect = datasetQueryBuilder
  .selectFrom('___activity_feed___')
  .select(({ fn }) => [
    fn.min('eventEndTime').as('minTime'),
    fn.max('eventEndTime').as('maxTime'),
  ]);

export type FeedDateRanges = InferResult<typeof feedDateRangeSelect>;
export type FeedDateRange = FeedDateRanges[number];

export const getFeedDateRangeQuery = (datasetId: string) => {
  return feedDateRangeSelect
    .where('datasetObjectId', '=', datasetId)
    .where('locationId', 'is not', null);
};
